import React from 'react';

// COMPONENT
export class PageToolbar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: '',
        };

        this.handleSearch = this.handleSearch.bind(this);
    }

    handleSearch(event) {
        this.setState({searchText: event.target.value});
        this.props.search(event.target.value);
    }

    render() {
        return (
            <nav className="subnav navbar-light bg-light">
                <div className="container">
                    <div className="filter-toolbar">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg">
                                    <input value={this.state.searchText} onChange={this.handleSearch} type="text" className="form-control searchbar" placeholder={this.props.placeholder}  />
                                </div>
                                <div className="col-sm right-detail">
                                    { this.props.rightComponent }
                                </div>
                                </div>
                            </div>
                        </div>
                        
                        
                </div>
            </nav>
            
        )
    }
}
